import { apiInterceptor } from './axios';
import { API_URL } from 'shared/api/Constants';

export const getPatientsListAPI = (data: any) => {
  // eslint-disable-next-line max-len
  return apiInterceptor
    .get(
      `${API_URL.PATIENTS_LIST}?listType=${data.listType}&date=${data.date}&providerName=${data.name}&role=${data.roleType}`
    )
    .then((response: any) => {
      return response;
    });
};

export const getAppointmentListAPI = (data: any) => {
  // eslint-disable-next-line max-len
  return apiInterceptor
    .get(`${API_URL.APPOINTMENT_LIST}?date=${data.date}&timezone=${data.timezone}`)
    .then((response: any) => {
      return response;
    });
};

export const getMdacPatientsListAPI = (data: any) => {
  return apiInterceptor
    .get(`${API_URL.MDAC_PATIENTS_LIST}?date=${data.date}`)
    .then((response: any) => {
      return response;
    });
};

export const getMdacPatientsOnboardingListAPI = (data: any) => {
  return apiInterceptor
    .get(`${API_URL.MDAC_PATIENTS_ONBOARDING}?tab=${data.tab}`)
    .then((response: any) => {
      return response;
    });
};

export const updateGridSettingsAPI = (data: any) => {
  return apiInterceptor
    .post(`${API_URL.GET_GRID_SETTINGS}/${data.gridName}`, data)
    .then((response: any) => {
      return response;
    });
};

export const getGridSettingsAPI = (data: any) => {
  return apiInterceptor
    .get(`${API_URL.GET_GRID_SETTINGS}/${data.gridName}`)
    .then((response: any) => {
      return response;
    });
};

export const getPatientDetailsAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.PATIENT_EHR_DETAILS}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const getPatientSnapshotDetailsAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.PATIENT_SNAPSHOT_DETAILS}/${patientId}`)
    .then((response: any) => {
      return response;
    });
};

export const getDrChronoChartIdDetailsAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.DR_CHRONO_CHART_DETAILS}/${patientId}`)
    .then((response: any) => {
      return response;
    });
};

export const getProviderOfficeLocationAPI = () => {
  return apiInterceptor
    .get(`${API_URL.GET_APPOINTMENT_PROVIDER_OFFICE_LOCATION}`)
    .then((response: any) => {
      return response;
    });
};

/**
 * MM-1198: Sync Offices button on the Provider Locations page - ehr-sync pulls the office details from DrChrono and
 * stores them in its DB only; its in-memory office cache is rebuilt by the daily early-morning job. Answers with the
 * number of offices stored (502 when DrChrono gave no usable answer).
 */
export const reloadAppointmentCacheAPI = () => {
  return apiInterceptor.get(`${API_URL.RELOAD_APPOINTMENT_CACHE}`).then((response: any) => {
    return response;
  });
};

export const getProviderOfficeExamRoomAPI = (officeId: number) => {
  return apiInterceptor
    .get(`${API_URL.GET_APPOINTMENT_OFFICE_LOCATION_EXAM_ROOM}/${officeId}`)
    .then((response: any) => {
      return response;
    });
};

export const getAppointmentAPI = (appointmentId: number) => {
  return apiInterceptor
    .get(`${API_URL.GET_APPOINTMENTS}/${appointmentId}`)
    .then((response: any) => {
      return response;
    });
};

export const saveAppointmentAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.SAVE_APPOINTMENT}`, data).then((response: any) => {
    return response;
  });
};

export const updateAppointmentAPI = (data: any) => {
  return apiInterceptor
    .put(`${API_URL.SAVE_APPOINTMENT}/${data.appointmentId}`, data)
    .then((response: any) => {
      return response;
    });
};

export const getStaffByUserAPI = (userId: number) => {
  return apiInterceptor
    .get(`${API_URL.GET_STAFF_LIST_BY_LOCATION_ID}/${userId}`)
    .then((response: any) => {
      return response;
    });
};

export const updateProviderAPI = (data: any) => {
  return apiInterceptor
    .put(`${API_URL.GET_STAFF_LIST_BY_LOCATION_ID}`, data)
    .then((response: any) => {
      return response;
    });
};

export const getAllProvidersAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_PROVIDERS}`).then((response: any) => {
    return response;
  });
};

export const updatePatientProviderAPI = (patientId: number, providerId: string) => {
  return apiInterceptor.put(`${API_URL.GET_PATIENT}/provider/${patientId}`, providerId).then((response: any) => {
    return response;
  });
};

export const getProviderLocationsAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_STAFF_LIST_BY_LOCATION_ID}`).then((response: any) => {
    return response;
  });
};

export const getProviderAPI = (officeId: number, profile: number) => {
  return apiInterceptor
    .get(`${API_URL.GET_APPOINTMENT_PROVIDERS}/${officeId}/${profile}`)
    .then((response: any) => {
      return response;
    });
};

export const getProfilesByLocationAPI = (officeId: number) => {
  return apiInterceptor
    .get(`${API_URL.GET_APPOINTMENT_PROFILES_BY_LOCATION}/${officeId}`)
    .then((response: any) => {
      return response;
    });
};

export const getProfilesByUserAndLocationsAPI = (userId: number, officeId: number) => {
  return apiInterceptor
    .get(
      `${API_URL.GET_APPOINTMENT_PROFILES_BY_USER_AND_LOCATIONS}/${userId}?locationId=${officeId}`
    )
    .then((response: any) => {
      return response;
    });
};

export const getGlobalProfilesByUserAPI = (userId: number) => {
  return apiInterceptor
    .get(`${API_URL.GET_APPOINTMENT_PROFILES_BY_USER}/${userId}`)
    .then((response: any) => {
      return response;
    });
};

export const getAppointmentViewAPI = (payload: any) => {
  return apiInterceptor.post(`${API_URL.GET_APPOINTMENTS_VIEW}`, payload).then((response: any) => {
    return response;
  });
};
export const getProfilesAPI = () => {
  return apiInterceptor.get(`${API_URL.GET_APPOINTMENT_PROFILES}`).then((response: any) => {
    return response;
  });
};

export const getDrChronoEventHistoryDetailsAPI = () => {
  return apiInterceptor.get(`${API_URL.DR_CHRONO_JOB_HISTORY}`).then((response: any) => {
    return response;
  });
};

export const archiveDrChronoJobEventAPI = (jobId: number, patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.ARCHIVE_JOB}/${jobId}/${patientId}`)
    .then((response: any) => {
      return response;
    });
};

export const getPaymentStatusAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.PAYMENT_STATUS}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const validatePaymentStatusAPI = (userId: number) => {
  return apiInterceptor.get(`${API_URL.VALIDATE_PAYMENT_STATUS}/${userId}`).then((response: any) => {
    return response;
  });
};

export const getUpcomingAppointmentAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.UPCOMING_APPOINTMENT_DETAILS}/${patientId}`)
    .then((response: any) => {
      return response;
    });
};
export const getPostMeetingDetailsAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.POST_MEETING_DETAILS}/admin/${patientId}`)
    .then((response: any) => {
      return response;
    });
};
export const getMCATIScoreAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.MCAT_I_SCORE_DETAILS}/${patientId}`)
    .then((response: any) => {
      return response;
    });
};

export const getMCATIScoreAppointmentAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.MCAT_I_SCORE_APPOINTMENT_DETAILS}/${patientId}`)
    .then((response: any) => {
      return response;
    });
};

export const addDrChronoChartDetailsAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.DR_CHRONO_CHART_DETAILS}`, data).then((response: any) => {
    return response;
  });
};

export const addPaymentStatusAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.PAYMENT_STATUS}`, data).then((response: any) => {
    return response;
  });
};


export const scheduleUpcomingAppointmentAPI = (data: any) => {
  return apiInterceptor
    .post(`${API_URL.UPCOMING_APPOINTMENT_DETAILS}`, data)
    .then((response: any) => {
      return response;
    });
};
export const addPostMeetingAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.POST_MEETING_DETAILS}`, data).then((response: any) => {
    return response;
  });
};

export const addMCATIScoreAPI = (data: any) => {
  return apiInterceptor.post(`${API_URL.MCAT_I_SCORE_DETAILS}`, data).then((response: any) => {
    return response;
  });
};

export const sendDocumentReminderAPI = (patientId: number) => {
  return apiInterceptor
    .post(`${API_URL.SEND_DOCUMENT_REMINDER}/${patientId}`)
    .then((response: any) => {
      return response;
    });
};

export const sendAssessmentReminderAPI = (data: { patientId: number; type: string }) => {
  const URL = `${API_URL.SEND_ASSESSNEBT_REMINDER}/${data?.type}/1.0/send/reminder/${data?.patientId}`;
  return apiInterceptor.post(`${URL}`).then((response: any) => {
    return response;
  });
};

export const downloadPDFAPI = (data: { patientId: number; type: string }) => {
  const URL = `${API_URL.SEND_ASSESSNEBT_REMINDER}/${data?.type}/1.0/report/${data?.patientId}`;
  return apiInterceptor.get(`${URL}`).then((response: any) => {
    return response;
  });
};

export const downloadWellnessParentPDFAPI = (data: { patientId: number; type: string }) => {
  const URL = `${API_URL.SEND_ASSESSNEBT_REMINDER}/${data?.type}/1.0/report/${data?.patientId}/parent`;
  return apiInterceptor.get(`${URL}`).then((response: any) => {
    return response;
  });
};

export const downloadWellnessChildPDFAPI = (data: { patientId: number; type: string }) => {
  const URL = `${API_URL.SEND_ASSESSNEBT_REMINDER}/${data?.type}/1.0/report/${data?.patientId}/child`;
  return apiInterceptor.get(`${URL}`).then((response: any) => {
    return response;
  });
};

export const getPostMeetingSummaryAPI = (patientId: number) => {
  return apiInterceptor
    .get(`${API_URL.POST_MEETING_SUMMARY}/${patientId}`)
    .then((response: any) => {
      return response;
    });
};

export const syncProfileAPI = (patientId: number) => {
  return apiInterceptor.get(`${API_URL.SYNC_PROFILE}/${patientId}`).then((response: any) => {
    return response;
  });
};

export const mwiseRatingAPI = () => {
  return apiInterceptor.get(`${API_URL.MWISE_FEEDBACK}`).then((response: any) => {
    return response;
  });
};

export const userReferralAPI = () => {
  return apiInterceptor.get(`${API_URL.REFERRAL_SOURCE}`).then((response: any) => {
    return response;
  });
};

export const getColumnsAPI = (userId: number) => {
  return apiInterceptor
    .get(`${API_URL.SAVE_COLUMNS}/${userId}/ALL_PATIENT`)
    .then((response: any) => {
      return response;
    });
};

export const saveColumnsAPI = (data: any) => {
  return apiInterceptor
    .post(`${API_URL.SAVE_COLUMNS}/${data.userId}/ALL_PATIENT`, data)
    .then((response: any) => {
      return response;
    });
};
